/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Draft_NoteInputs */

const en_directory_submit_workspace_draft_note = /** @type {(inputs: Directory_Submit_Workspace_Draft_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving a draft does not submit it. Choose a plan on the review step to continue.`)
};

const zh_directory_submit_workspace_draft_note = /** @type {(inputs: Directory_Submit_Workspace_Draft_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存草稿不会提交。请在审核步骤选择方案后继续。`)
};

/**
* | output |
* | --- |
* | "Saving a draft does not submit it. Choose a plan on the review step to continue." |
*
* @param {Directory_Submit_Workspace_Draft_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_draft_note = /** @type {((inputs?: Directory_Submit_Workspace_Draft_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Draft_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_draft_note(inputs)
	return zh_directory_submit_workspace_draft_note(inputs)
});
export { directory_submit_workspace_draft_note as "directory.submit.workspace.draft_note" }